{
    "name": "dls-frontend",
    "version": "1.0.19",
    "scripts": {
        "ng": "ng",
        "ng-openapi-gen": "ng-openapi-gen",
        "ng-openapi-gen-v3": "ng-openapi-gen --config ng-openapi-gen-v3.json",
        "ng-openapi-gen-bff": "ng-openapi-gen -c openapi-configs/openapi-bff.json",
        "ng-openapi-gen-all": "npm run ng-openapi-gen && npm run ng-openapi-gen-v3 && npm run ng-openapi-gen-bff",
        "swagger-get-sia": "node generate-api-usage/sia/swagger-get-sia-proxy.js",
        "swagger-get-sia:dev": "node generate-api-usage/sia/swagger-get-sia-proxy.js dev",
        "swagger-get-sia:prod": "node generate-api-usage/sia/swagger-get-sia-proxy.js prod",
        "swagger-get-sia:test": "node generate-api-usage/sia/swagger-get-sia-proxy.js test",
        "swagger-get-sia:apitest": "node generate-api-usage/sia/swagger-get-sia-proxy.js apitest",
        "ng-openapi-gen-sia": "npm run swagger-get-sia && ng-openapi-gen --config generate-api-usage/sia/ng-openapi-gen.json",
        "generate:api:sia:dev": "npm run swagger-get-sia:dev && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-bff.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json",
        "generate:api:sia:prod": "npm run swagger-get-sia:prod && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-bff.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json",
        "generate:api:sia:test": "npm run swagger-get-sia:test && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-bff.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json",
        "generate:api:sia:apitest": "npm run swagger-get-sia:apitest && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-bff.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.json",
        "generate:api:dev": "ng-openapi-gen -c openapi-configs/openapi-main.dev.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.dev.json && npm run ng-openapi-gen-bff",
        "generate:api:prod": "ng-openapi-gen -c openapi-configs/openapi-main.prod.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.prod.json && npm run ng-openapi-gen-bff",
        "generate:api:test": "ng-openapi-gen -c openapi-configs/openapi-main.test.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.test.json && npm run ng-openapi-gen-bff",
        "generate:api:apitest": "ng-openapi-gen -c openapi-configs/openapi-main.apitest.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.apitest.json && npm run ng-openapi-gen-bff",
        "generate:api:localDev": "ng-openapi-gen -c openapi-configs/openapi-main.localDev.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.localDev.json && npm run ng-openapi-gen-bff",
        "start": "ng serve --host=0.0.0.0 --configuration=development",
        "start:dev": "node scripts/ensure-dev-ssl.js && node scripts/generate-api-dev.js && ng serve --host=0.0.0.0 --configuration=development --ssl-cert=.dev-ssl/cert.pem --ssl-key=.dev-ssl/key.pem",
        "start:prod": "npm run generate:api:prod && ng serve --host=0.0.0.0 --configuration=prod",
        "start:test": "npm run generate:api:test && ng serve --host=0.0.0.0 --configuration=test",
        "start:apitest": "npm run generate:api:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
        "start:localDev": "npm run generate:api:localDev && ng serve --host=0.0.0.0 --configuration=localDev",
        "start-sia": "npm run ng-openapi-gen-sia && ng serve --host=0.0.0.0",
        "start:sia:dev": "npm run generate:api:sia:dev && ng serve --host=0.0.0.0 --configuration=development",
        "start:sia:prod": "npm run generate:api:sia:prod && ng serve --host=0.0.0.0 --configuration=prod",
        "start:sia:test": "npm run generate:api:sia:test && ng serve --host=0.0.0.0 --configuration=test",
        "start:sia:apitest": "npm run generate:api:sia:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
        "build": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build",
        "build:dev": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build --configuration dev",
        "build:prod": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build --configuration production",
        "build:test": "npm run generate:api:test && node prebuild.js && ng build --configuration test",
        "build:api-test": "npm run generate:api:apitest && node prebuild.js && ng build --configuration apitest",
        "generate:api-usage": "cd generate-api-usage && npm i && node index.js",
        "test": "ng test",
        "test:vitest": "vitest run --config vitest.config.ts",
        "test:vitest:watch": "vitest --config vitest.config.ts",
        "format:write": "prettier --write \"src/**/*{.ts,.json,.css,.scss,.html}\""
    },
    "private": true,
    "dependencies": {
        "@almothafar/angular-signature-pad": "^8.0.0",
        "@angular-eslint/schematics": "^21.3.1",
        "@angular/animations": "^21.2.7",
        "@angular/cdk": "^21.2.5",
        "@angular/common": "^21.2.7",
        "@angular/compiler": "^21.2.7",
        "@angular/core": "^21.1.1",
        "@angular/forms": "^21.2.7",
        "@angular/material": "^21.2.5",
        "@angular/material-luxon-adapter": "^21.2.5",
        "@angular/material-moment-adapter": "^21.2.5",
        "@angular/platform-browser": "^21.2.7",
        "@angular/platform-browser-dynamic": "^21.2.7",
        "@angular/router": "^21.2.7",
        "@messageformat/core": "^3.3.0",
        "@ngneat/dialog": "^5.2.1",
        "@ngneat/until-destroy": "^10.0.0",
        "@ngrx/signals": "^21.1.0",
        "@ngx-translate/core": "^15.0.0",
        "@ngx-translate/http-loader": "^8.0.0",
        "@sentry/angular": "^10.56.0",
        "@zxing/browser": "0.1.5",
        "@zxing/library": "^0.21.0",
        "@zxing/ngx-scanner": "^21.0.0",
        "blob-util": "^2.0.2",
        "bootstrap": "^5.3.3",
        "dayjs": "^1.11.11",
        "dls-frontend": "file:",
        "heic2any": "^0.0.4",
        "html-to-image": "^1.11.11",
        "luxon": "^3.4.4",
        "magic-bytes.js": "^1.10.0",
        "material-symbols": "^0.18.0",
        "moment": "^2.30.1",
        "ng-qrcode": "^21.0.0",
        "ng-table-virtual-scroll": "^1.6.1",
        "ngx-extended-pdf-viewer": "^25.6.4",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "ngx-translate-messageformat-compiler": "^7.0.0",
        "rxjs": "~7.8.1"
    },
    "devDependencies": {
        "@analogjs/vite-plugin-angular": "^2.4.5",
        "@analogjs/vitest-angular": "^2.4.5",
        "@angular-eslint/builder": "^21.3.1",
        "@angular-eslint/eslint-plugin": "^21.3.1",
        "@angular-eslint/eslint-plugin-template": "^21.3.1",
        "@angular-eslint/template-parser": "^21.3.1",
        "@angular/build": "^21.1.1",
        "@angular/cli": "^21.1.1",
        "@angular/compiler-cli": "^21.2.7",
        "@types/jasmine": "~5.1.4",
        "@types/luxon": "^3.4.2",
        "@types/node": "^25.5.2",
        "@typescript-eslint/eslint-plugin": "7.11.0",
        "@typescript-eslint/parser": "7.11.0",
        "autoprefixer": "^10.4.19",
        "eslint": "^9.3.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-prettier": "^5.1.3",
        "jasmine-core": "^5.1.2",
        "jasmine-spec-reporter": "~7.0.0",
        "jsdom": "^29.0.2",
        "karma": "~6.4.3",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.1.0",
        "ng-openapi-gen": "^0.51.0",
        "node-fetch": "^3.3.2",
        "postcss": "^8.4.38",
        "prettier": "^3.2.5",
        "prettier-eslint": "^16.3.0",
        "prettier-plugin-tailwindcss": "^0.5.14",
        "tailwindcss": "^3.4.3",
        "ts-node": "~10.9.2",
        "tslib": "^2.6.2",
        "typescript": "~5.9.2",
        "vitest": "^4.1.4"
    }
}
